iScreenWizard.factory('Competentieprofiel', function ($q, Ajax) {

    var data = {};

    data.all = function(params) {
        if (typeof params === 'undefined') {
            params = {};
        }
        return $q(function (resolve, reject) {
            Ajax.get('competentieprofiel', params).then(function (response) {
                var competentieprofielen = response.data;
                resolve(competentieprofielen);
            }, reject);
        });
    };

    data.get = function(id) {
        return $q(function (resolve, reject) {
            Ajax.get('competentieprofiel/'+id).then(function (response) {
                var competentieprofiel = response.data;
                resolve(competentieprofiel);
            }, reject);
        });
    };

    data.getLinkedCompetentieIdeaalscores = function(competentieprofiel) {
        return $q(function (resolve, reject) {
            params = {
                _method: 'get_gelinkte_competenties_ideaalscores',
            };
            Ajax.get('competentieprofiel/'+competentieprofiel.id, params).then(function (response) {
                resolve(response.data.ideaalscore_per_competentie_id);
            }, reject);
        });
    };

    data.linkCompetentieIdeaalscores = function(competentieprofiel) {
        return $q(function (resolve, reject) {
            params = {
                _method: 'link_competenties_ideaalscores',
                ideaalscore_per_competentie_id: []
            };
            angular.forEach(competentieprofiel.competenties, function(competentie) {
                // Check if ideaalscore is available, else set it to 'none'
                if ('ideaalscore' in competentie && competentie.ideaalscore != null) {
                    ideaalscore = competentie.ideaalscore;
                } else {
                    ideaalscore = 'none';
                }
                params.ideaalscore_per_competentie_id[competentie.id] = ideaalscore;
            });
            Ajax.post('competentieprofiel/'+competentieprofiel.id, params).then(function (response) {
                resolve(response);
            }, reject);
        });
    };

    data.downloadVoorbeeld = function(competentieprofiel) {
        params = {};
        params._method = 'genereer_rapport';
        params.competentieprofiel_id = competentieprofiel.id;

        return $q(function (resolve, reject) {
            Ajax.get('competentieprofiel', params).then(function (response) {
                resolve(response);
            }, reject);
        });
    };

    return data;
});